import { ChevronDown, Download, FileSpreadsheet, FileText } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

interface ReportDropdownProps {
  // Visible label on the trigger button — the report name.
  label: string
  onDownloadPdf: () => void
  onDownloadXlsx: () => void
}

// Reusable report-download dropdown — outline button labelled with
// the report name, opens a menu with PDF / Excel choices. Used in
// the PageHeader actions on FabricationView + CompletedView so
// every downloadable report has the same affordance.
export function ReportDropdown({
  label,
  onDownloadPdf,
  onDownloadXlsx,
}: ReportDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Download className="size-4" />
          {label}
          <ChevronDown className="size-3 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem onClick={onDownloadPdf}>
          <FileText className="size-4" />
          PDF
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onDownloadXlsx}>
          <FileSpreadsheet className="size-4" />
          Excel
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
